import React, { useEffect } from "react";
import { Box, Button, ButtonBase, Divider, List, ListItem, Modal, Portal, Stack, Typography } from "@mui/material";
// import quatos from '../../../assets/images/quote_s.svg';
// import quatoe from '../../../assets/images/quote_e.svg';
// import logo from '../../../assets/images/logo_w.svg';
// import notepad from '../../../assets/images/notepad.svg';
import { useOrderStore } from "../../../store/order";
import { ICart } from "../../../types/menu";
import { useInfoStore } from "../../../store/userInfo";
import { useTranslation } from "react-i18next";
import { useWindowDimensions } from "../../../App";
import { isBrowser } from 'react-device-detect';
import { ICompleteList, IOrderModifiers } from "../../../types/menu";
import { TurnLeft } from "@mui/icons-material";
import { logger } from "../../../utils/logger";

const CompleteModal = (props:any) => {
  const { userInfo, currentLng } = useInfoStore();
  const { width, height } = useWindowDimensions();
  const { completeList, openComplete, setOpenComplete, setCompleteList } = useOrderStore();
  const storeId = userInfo?.storeId;
  const {t} =  useTranslation(`${storeId}`)
  const { orientation } = useWindowDimensions()
  const landMode = (orientation === "landscape") ?true: false

  const  hideDialog = () => {
    // if (!isBrowser) {
    //   if (window.ReactNativeWebView !== undefined) {
    //     window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
    //   } else if(window.Android !== undefined){
    //     window.Android.postMessage(JSON.stringify({'type':'play'}));
    //   }
    // }
    setCompleteList({}as ICompleteList)
    setOpenComplete(false)
  }

  const renderModifiers = (orderModifiers: IOrderModifiers[], level = 0) => {
    logger.debug(`Rendering level ${level} modifiers:`, orderModifiers);
    return orderModifiers.map((modifier, orderModifierIdx) => (
      <Box>
        <Box
          key={`${modifier.modifierId}-${level}-${orderModifierIdx}`}
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: "center",
            pl: `${level * 2.0}rem`, // Indentation for nested levels
          }}
        >
          {/* {level !== 0 && <TurnLeft sx={{transform: "rotate(180deg)"}}/>} */}
          <Typography
            sx={{
              color: '#F72E13',
              fontSize: '1.8rem',
              fontWeight: '400',
              fontStyle: 'normal',
              letterSpacing: '-.018rem',
              textAlign: "left",
              flex: 1,
            }}
          >
            {t(`${storeId}:optionNames.${modifier.modifierId}.${currentLng}`)}
            {/* {modifier.modifierName} */}
          </Typography>
          <Typography
            sx={{
              color: '#F72E13',
              textAlign: 'right',
              fontSize: '1.8rem',
              fontWeight: '400',
              fontStyle: 'normal',
              width: '4.0rem',
            }}
          >
            x{modifier.quantity}
          </Typography>
          <Typography
            sx={{
              color: '#F72E13',
              fontSize: '1.8rem',
              fontWeight: '400',
              fontStyle: 'normal',
              textAlign: 'right',
              width: '8.5rem',
            }}
          >
            ${(modifier.modifierPrice / 100).toFixed(2)}
          </Typography>
          {/* Recursively render nested modifiers */}
        </Box>
        {modifier.orderModifiers && renderModifiers(modifier.orderModifiers, level + 1)}
      </Box>
    ));
  };

  const renderOrderItems = (orderItems: ICart[]) => {
    return orderItems.map((orderItem: ICart, orderIdx) => (
      <ListItem key={orderIdx} sx={{ width: '62.3rem', padding: '0rem 2.0rem' }}>
        <Stack>
          <Box sx={{ display: 'flex', flexDirection: 'row', gap: '4.0rem' }}>
            <Typography
              sx={{
                fontSize: '2.0rem',
                fontWeight: '600',
                fontStyle: 'normal',
                letterSpacing: '-.02rem',
                width: '41.8rem',
              }}
            >
              {t(`${storeId}:itemNames.${orderItem.itemId}.${currentLng}`)}
            </Typography>
            <Typography
              sx={{
                textAlign: 'right',
                fontSize: '2.0rem',
                fontWeight: '700',
                fontStyle: 'normal',
                width: '4.0rem',
                height: '3.0rem',
              }}
            >
              x{orderItem.quantity}
            </Typography>
            <Typography
              sx={{
                textAlign: 'right',
                fontSize: '2.0rem',
                fontWeight: '700',
                fontStyle: 'normal',
                width: '8.5rem',
                height: '3.0rem',
              }}
            >
              ${(orderItem.itemPrice / 100).toFixed(2)}
            </Typography>
          </Box>
          {/* Render orderModifiers recursively */}
          {orderItem.orderModifiers && renderModifiers(orderItem.orderModifiers)}
          <Divider sx={{ background: '#000', height: '.2rem', width: '62.3rem', my: '2.0rem' }} />
        </Stack>
      </ListItem>
    ));
  };

  if(Object.keys(completeList).length === 0 ) return <></>
    return (
      <Portal>
        <Modal
          keepMounted
          disableScrollLock
          disableEnforceFocus
          hideBackdrop
          open={openComplete}
          onClose={hideDialog}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{ //You can copy the code below in your theme
            background: 'rgba(0,0,0,0.5)',
            '& .MuiBackdrop-root': {
              backgroundColor: 'transparent' // Try to remove this to see the result
            }
          }}
        >
				  <Box key={completeList.orderNo} sx={[modal]}>
            <Box sx={{display: 'flex', flexDirection: landMode? 'row':'column'}}>
              {landMode ? 
                <Box sx={{width: '57.3rem', flex:1, p: '28.7rem 8.8rem', justifyContent: 'center', alignItems: 'center', background: '#F72E13', borderRadius: '1.5rem 0rem 0rem 1.5rem'}}>
                    <img src={process.env.PUBLIC_URL+'/assets/images/quote_s.svg'} alt="quotes" style={{position: 'absolute', left: '8.0rem', top: '24.7rem', width: '6.0rem', height: '6.0rem'}}/>
                    <Typography style={{width: '39.7rem', height: '13.6rem', fontSize: '4.5rem', fontWeight: '900', fontStyle: 'normal', lineHeight: '150%', letterSpacing: '.225rem', color: '#fff', textAlign: 'center'}}>YOUR ORDER RECEIVED</Typography>
                    <img src={process.env.PUBLIC_URL+'/assets/images/quote_e.svg'} alt="quotee" style={{position: 'absolute', left: '40.5rem', bottom: '36.2rem', width: '6.0rem', height: '6.0rem'}} />
                    <img src={process.env.PUBLIC_URL+'/assets/images/logo_w.svg'} alt="logo" style={{position: 'absolute', left: '23.0rem', bottom: '4.2rem', width: '11.3rem', height: '5.0rem'}} />
                </Box> : 
                <Box sx={{width: '100%', height: '10rem', p: '1.7rem 1.8rem',display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#F72E13', borderRadius: '1.5rem 1.5rem 0rem 0rem'}}>
                    <img src={process.env.PUBLIC_URL+'/assets/images/quote_s.svg'} alt="quotes" style={{ width: '4.0rem', height: '4.0rem', marginBottom: '2rem'}}/>
                    <Typography style={{width: '50.0rem', fontSize: '4.0rem', fontWeight: '900', fontStyle: 'normal', lineHeight: '150%', letterSpacing: '.225rem', color: '#fff', textAlign: 'center'}}>YOUR ORDER RECEIVED</Typography>
                    <img src={process.env.PUBLIC_URL+'/assets/images/quote_e.svg'} alt="quotee" style={{ width: '4.0rem', height: '4.0rem', marginTop: '2rem'}} />
                </Box>
              }
              <Stack sx={{width: '70.7rem', padding: '2.0rem 2.2rem', borderRadius: landMode ? '0rem 1.5rem 1.5rem 0rem' : '1.5rem', background: '#fff'}}>
                <Box sx={{display: 'flex', flexDirection: 'row', margin: '0rem 2.9rem' }}>
                  <Typography sx={{borderRadius: '6.0rem 0rem 0rem 6.0rem', background: '#000', padding: '2.3rem 3.6rem', alignItems: 'center', flexShrink: 0, justifyContent: 'center', color: '#fff',
                    fontSize: '2.4rem', fontWeight: '700', fontStyle: 'normal'}}>Order DETAIL</Typography>
                  <Typography sx={{borderRadius: '0rem 6.0rem 6.0rem 0rem', border: '4px solid #000', background: '#fff', width: '38.4rem', padding: '1.9rem 6.2rem', justifyContent: 'center',
                     alignItems: 'center', flexShrink: 0, fontSize: '2.4rem', fontWeight: '600', fontStyle: 'normal' }}>Order No. {completeList.orderNo}</Typography>
                </Box>
                <List sx={{ mt: '3.0rem', height: '50.5rem', overflow: 'auto', overflowX: 'hidden' }}>
                  {completeList && completeList.orderItems && renderOrderItems(completeList.orderItems)}
                </List>
 
                <Divider sx={{background: '#000', height: '.5rem', width: '62.3rem', margin: '0rem 2.0rem'}}/>
                <Box sx={{display: 'flex', flexDirection: 'row', my: '1.0rem', mx: '2.0rem', justifyContent: 'space-between', alignItems: 'center'}}>
                  <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', width: '100%' }}>
                    <Typography sx={{ color: '#000', fontSize: '2.6rem', fontWeight: '700', fontStyle: 'normal', display: 'flex', alignItems: 'center' }}>
                      Subtotal
                      <span style={{ color: '#999999', fontSize: '1.6rem', fontWeight: '600', fontStyle: 'normal', marginLeft: '1rem' }}>
                        (Tax not included in the price)
                      </span>
                    </Typography>
                  </Box>
                  <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end'}}>
                    <Typography sx={{fontSize: '2.6rem', fontWeight: '700', fontStyle: 'normal', textAlign: 'right'}}>${(completeList.totalAmount/100).toFixed(2)}</Typography>
                  </Box>
                </Box>
                
                <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                  <ButtonBase sx={{ display: 'flex', width: '20.0rem', height: '5.5rem', padding: '.4rem 3.3rem', alignItems: 'center', justifyContent: 'center', borderRadius: '3.0rem', backgroundColor: '#F72E13'}}
                    onClick={()=> hideDialog()}>
                    <Typography sx={{fontSize: '2.6rem', fontWeight: '60.0', fontStyle: 'normal', lineHeight: '150%', color: '#fff', textAlign: 'center'}}>Close</Typography>
                  </ButtonBase>
                </Box>
              </Stack>
            </Box>
          </Box>
        </Modal>
      </Portal>
    ) 
  };

  const modal = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    // border: '2rem solid #fff',
    borderRadius: '1.5rem',
    boxShadow: '0rem 0rem 5.0rem 0rem rgba(0, 0, 0, 0.40)'
  
  };
  
  export default CompleteModal;
